/* =========================================================
   ROHHカスタム: Clickable image banner (no core edit)
   使い方:
   - 画像バナーの「ボタン1のラベル」を ROHH_LINK にする（完全一致）
   - ボタン1のリンク：画像1のリンク
   - ボタン2のリンク（任意）：画像2のリンク（未設定なら画像2もボタン1と同じリンク）
   → 対象バナーだけ、画像（media）がクリックできる + ボタン非表示
   ========================================================= */

(() => {
  const MAGIC_LABEL = "ROHH_LINK";

  function applyClickableBanners(root = document) {
    root.querySelectorAll(".shopify-section").forEach((section) => {
      const banner = section.querySelector(".banner");
      if (!banner) return;

      // ボタン1/2を取得（ボタンが無い場合は対象外）
      const buttons = Array.from(section.querySelectorAll(".banner__buttons a.button, .banner__buttons a"));
      if (!buttons.length) return;

      const btn1 = buttons[0];
      const btn2 = buttons[1] || null;

      // 対象判定：ボタン1のラベルが ROHH_LINK のときだけ
      const label1 = (btn1.textContent || "").trim();
      if (label1 !== MAGIC_LABEL) return;

      const href1 = btn1.getAttribute("href");
      if (!href1 || href1 === "#") return;

      const href2 = btn2?.getAttribute("href");
      const hasHref2 = !!(href2 && href2 !== "#");

      // 画像(media)を全部取る（1枚でも2枚でも対応）
      const medias = Array.from(section.querySelectorAll(".banner__media"));
      if (!medias.length) return;

      medias.forEach((media, idx) => {
        // 二重生成防止
        if (media.querySelector("a.rohh-banner__media-link")) return;

        // 1枚目はhref1、2枚目はhref2（無ければhref1）
        const href = idx === 1 && hasHref2 ? href2 : href1;
        const srcBtn = idx === 1 && hasHref2 ? btn2 : btn1;

        // 画像の上に透明リンクを被せる
        const a = document.createElement("a");
        a.className = "rohh-banner__media-link";
        a.href = href;
        a.setAttribute("aria-label", "Open banner link");

        // target/relがあれば引き継ぐ
        if (srcBtn?.target) a.target = srcBtn.target;
        if (srcBtn?.rel) a.rel = srcBtn.rel;

        media.appendChild(a);
      });

      // CSSを効かせるためのクラス（←これが大事）
      banner.classList.add("rohh-banner--clickable");
    });
  }

  // 通常表示（ストア側）
  document.addEventListener("DOMContentLoaded", () => applyClickableBanners());

  // テーマエディタ（セクション再描画に追従）
  document.addEventListener("shopify:section:load", (e) => applyClickableBanners(e.target));
  document.addEventListener("shopify:section:select", (e) => applyClickableBanners(e.target));

  // 念のため：動的に差し替えられるケース用の保険（軽め）
  const mo = new MutationObserver(() => applyClickableBanners());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();